export const circuitFieldTypes = {
  circuitVendorId: { type: "text", width: 80, section: "circuit" },

  status: {
    type: "select",
    width: 100,
    inlineGroup: "statusUse",
    section: "circuit",
  },
  use: {
    type: "select",
    width: 95,
    inlineGroup: "statusUse",
    section: "circuit",
  },
  type: { type: "select", section: "circuit" },
  category: { type: "select", section: "circuit" },
  // scope: { type: "select", section: "circuit" },

  carrier: { type: "select", width: 80, section: "carrier" },
  lec: { type: "select", width: 80, section: "carrier" },

  accessBandwidthConverted: {
    type: "text",
    width: 50,
    inlineGroup: "accessUnit",
    section: "carrier",
  },
  accessBandwidthUnit: {
    type: "select",
    width: 35,
    inlineGroup: "accessUnit",
    section: "carrier",
  },

  portBandwidthConverted: {
    type: "text",
    width: 50,
    inlineGroup: "portUnit",
    section: "carrier",
  },
  portBandwidthUnit: {
    type: "select",
    width: 35,
    inlineGroup: "portUnit",
    section: "carrier",
  },

  handoffType: { type: "select", width: 85, section: "carrier" },
  redundancyType: { type: "select", section: "carrier" },
  diversityGroups: { type: "diversity", width: 120, section: "carrier" },

  forecastDeliveryDate: { type: "date", width: 60, section: "delivery" },
  actualHandoverDate: { type: "date", width: 60, section: "delivery" },
  cutoverDate: { type: "date", width: 60, section: "delivery" },
  requestedDisconnectDate: { type: "date", width: 60, section: "delivery" },

  actualBillingStartDate: { type: "date", width: 60, section: "billing" },
  actualBillingStopDate: { type: "date", width: 60, section: "billing" },
  currentTermEndDate: { type: "date", width: 60, section: "billing" },

  currency: { admin: true, type: "select", width: 90, section: "billing" },
  billToCountry: { admin: true, type: "select", width: 90, section: "billing" },
  mrcBaseline: { admin: true, type: "text", width: 90, section: "billing" },
};
